<<template>
    <pm-custom-dialog v-if="visible" v-model="visible">

        <div slot="close-btn" @click="startSpin" style="position: absolute; width: 28px; height: 28px; background: #fff; line-height: 22px; text-align: center; top: 22px; right: 12px; border: 2px solid #ddd; border-radius: 50%;" class="main-dialog--close">
            <span style="font-weight: 600;"><v-icon style="font-size: 16px;">close</v-icon></span>
        </div>

        <div style="display: flex; text-align: left; justify-content: flex-start; align-items: center; justify-content: center; margin-bottom: 16px;">
            <img style="width: 46px; height: 46px; margin: 7px 10px 0px 0px;" alt="DentiCalc" src="/images/dc_4in1_150_150.png">
            <h2 style="font-size: 18px; line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">
                DentiCalc Premium
                <br/>
                SUPER SALE
            </h2>
        </div>
        <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; width: 100%;">
            <v-btn :disabled="wheelSpinning" class="primary" ref="spinBtn" style="border-radius: 16px; margin-bottom: 30px;" large @click="startSpin">
                <span style="text-transform: uppercase!important;">
                    SPIN THE WHEEL
                </span>
            </v-btn>
        </div>

        <div style="position: relative;">
            <div class="the_wheel" align="left" valign="top">
                <canvas data-toggle-fullscreen id="canvas" style="" :width="width" :height="width">
                    <p style="{color: white}" align="center">Sorry, your browser doesn't support canvas. Please try another.</p>
                </canvas>
                <div style="position: absolute; top: 13px; left: 50%; margin-left: -5px; width: 0; height: 0; border-style: solid; border-width: 20px 10px 0 10px; border-color: #fff transparent transparent transparent;" />
                <div style="position: absolute; top: 7px; left: 50%; margin-left: -5px; width: 0; height: 0; border-style: solid; border-width: 20px 10px 0 10px; border-color: #000 transparent transparent transparent;" />

            </div>
        </div>
    </pm-custom-dialog>
</template>
<script>
import PmCustomDialog from "./base-dialog.vue";
export default {
    components: {
        PmCustomDialog
    },
    data: () => ({
        visible: false,
        wheelSpinning: false,
        width: document.body.clientWidth - 30,
    }),
    methods: {
        init() {
            window.setTimeout(() => {
                try {
                    const el = document.querySelector('.pm-custom-dialog-contentsdfsd');
                    if (el) this.width = el.clientWidth;
                    // this.audio = new Audio('https://cdn.denticalc.com/audio/tick.mp3');
                    this.segments = this.setSegments();
                    this.$nextTick(()=>{
                        this.theWheel = this.initWheel();
                        this.$refs.spinBtn.$el.classList.add("pm-btn-glowing");
                    });

                    window.Tracker.logEvent({
                        event_name: "show_offer",
                        event_category: "offer",
                        event_label: "winwheel",
                    });
                } catch (error) {
                    window.captureException(error);
                    this.close();
                }
            }, 500);
        },
        playSound() {
            this.audio.pause();
            this.audio.currentTime = 0;
            this.audio.play();
        },
        initWheel() {
            return new Winwheel({
                'textFontFamily': 'Lato',
                'responsive': true,
                'strokeStyle': '#ffffff',
                'lineWidth': 3,
                'textFillStyle': '#ffffff',
                'pointerAngle': 0,
                'outerRadius': (this.width / 2) - 15,        // Set outer radius so wheel fits inside the background.
                'innerRadius': 0,         // Make wheel hollow so segments don't go all way to center.
                'textFontSize': 24,         // Set default font size for the segments.
                'textOrientation': 'horizontal', // Make text vertial so goes down from the outside of wheel.
                'textAlignment': 'outer',    // Align text to outside of wheel.
                'numSegments': this.segments.length,         // Specify number of segments.
                'segments': this.segments,            // Define segments including colour and text.
                'animation':           // Specify the animation to use.
                    {
                        'type': 'spinToStop',
                        'duration': 10,    // Duration in seconds.
                        'spins': 1,     // Default number of complete spins.
                        'callbackFinished': (indicatedSegment) => {
                            this.alertPrize(indicatedSegment);
                        },
                        // 'callbackSound': this.playSound,   // Function to call when the tick sound is to be triggered.
                        // 'soundTrigger': 'pin'        // Specify pins are to trigger the sound, the other option is 'segment'.
                    },
                'pins':				// Turn pins on.
                    {
                        'number': this.segments.length,
                        'fillStyle': 'white',
                        'strokeStyle': 'white',
                        'outerRadius': 4,
                    }
            });
        },
        setSegments() {
            /********** EDIT AMOUNTS HERE!!!! ***********/
	        const amount1 = 20;
	        const amount2 = 0;
	        const retryamount = 0;
	        /********* DO NOT EDIT BELOW THIS LINE ************/

            return [
                {'fillStyle': '#000000', 'text': 'SPIN AGAIN', id: 0, amount: retryamount, textFontSize: 16 },
                {'fillStyle': '#ffaa07', 'text': '-70%', id: 1, amount: amount1},
                {'fillStyle': '#327392', 'text': '-30%', id: 2, amount: amount2},
                {'fillStyle': '#00aef0', 'text': '-10%', id: 2, amount: amount2},
                {'fillStyle': '#000000', 'text': 'SPIN AGAIN', id: 0, amount: retryamount, textFontSize: 16},
                {'fillStyle': '#00aef0', 'text': '-15%', id: 2, amount: amount2},
                {'fillStyle': '#f6989d', 'text': '-50%', id: 2, amount: amount2},
                {'fillStyle': '#00aef0', 'text': '-30%', id: 2, amount: amount2},
                {'fillStyle': '#327392', 'text': '-10%', id: 2, amount: amount2},
                {'fillStyle': '#00aef0', 'text': '-5%', id: 2, amount: amount2},
                {'fillStyle': '#327392', 'text': '-20%', id: 2, amount: amount2}
            ];
        },


        startSpin() {
            if (this.wheelSpinning !== false) return;
            this.resetWheel();
            this.theWheel.animation.spins = this.getRandomSpins();
            let randSegment = this.getRandomSegment();
            let startAngle = this.theWheel.segments[randSegment].startAngle;
            let endAngle = this.theWheel.segments[randSegment].endAngle;
            let range = (endAngle - startAngle) - 2;
            let toStop = startAngle + 1 + Math.floor((Math.random() * range));
            if (Math.floor(toStop - startAngle) < 3) toStop+=3;
            if (Math.floor(endAngle - toStop) < 3) toStop-= 3;
            this.theWheel.animation.stopAngle = toStop;
            this.theWheel.startAnimation();
            this.wheelSpinning = true;
            console.log(this.$refs.spinBtn);
            this.$refs.spinBtn.$el.classList.remove("pm-btn-glowing");
        },
        alertPrize(indicatedSegment) {
            if (indicatedSegment.id === 0) {
                this.wheelSpinning = false;
                this.$refs.spinBtn.$el.classList.add("pm-btn-glowing");
                return;
            } else {
                localStorage.setItem('winwhell', + new Date());;
                this.$bus.$emit('openAppDialog','discount');
                this.$bus.$emit('updateAppBar');
                window.Tracker.logEvent({
                    event_name: "show_offer",
                    event_category: "offer",
                    event_label: "winwheel_spin",
                });
            }
        },
        getRandomSegment() {
            let segmentIds = [];
            let actualSegments = this.segments;
            for (let i = 0; i < actualSegments.length; i++) {
                let segment = actualSegments[i];
                let available = segment.amount;
                while (available > 0) {
                    segmentIds.push(i + 1);
                    available--;
                }
            }
            let randomId = segmentIds[this.getRandomInt(0, segmentIds.length)];
            return randomId;
        },
        getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min)) + min;
        },
        getRandomSpins() {
            let num = this.getRandomInt(2, 6);
            return num;
        },
        resetWheel() {
            this.theWheel.stopAnimation(false);  // Stop the animation, false as param so does not call callback function.
            this.theWheel.rotationAngle = 0;     // Re-set the wheel angle to 0 degrees.
            this.theWheel.draw();                // Call draw to render changes to the wheel.
            this.wheelSpinning = false;          // Reset to false to power buttons and spin can be clicked again.
        },
        show() {
            this.visible = true;
            this.init();
        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
    }
}
</script>
>
